/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//AnkerLink
$(function(){
  $('a[href^="#"]').click(function(){
    var adjust = 100;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});


//pagetop
$(window).on("scroll" ,function(){
    if( $(window).scrollTop() > 300){
        $('#pagetop').fadeIn();
    }else{
        $('#pagetop').fadeOut();
    }
});

//Happy Birthday app Form テキスト書き換え
function updateFormFields() {
  const userFirstName = document.querySelector('#hb_first_name_wrapper').firstElementChild;
  userFirstName.textContent = '名';

  const userLastName = document.querySelector('#hb_last_name_wrapper').firstElementChild;
  userLastName.textContent = '姓';

  const userEmail = document.querySelector('#hb_email_address_wrapper').firstElementChild;
  userEmail.textContent = 'メールアドレス';

  const userYear = document.querySelector('#bd_yyyy_wrapper').firstElementChild;
  userYear.textContent = '西暦';

  const placeYear = document.querySelector("#bd_yyyy");
  placeYear.placeholder = '2000';

  const userMonth = document.querySelector('#bd_mm_wrapper').firstElementChild;
  userMonth.textContent = '月';

  const placeMonth = document.querySelector("#bd_mm");
  placeMonth.placeholder = '01';

  const userDay = document.querySelector('#bd_dd_wrapper').firstElementChild;
  userDay.textContent = '日';

  const placeDay = document.querySelector("#bd_dd");
  placeDay.placeholder = '01';
}

updateFormFields();

//Happy Birthday app Form id属性の順序入替え
function swapElements() {
  const firstNameWrapper = document.querySelector('#hb_first_name_wrapper');
  const lastNameWrapper = document.querySelector('#hb_last_name_wrapper');

  if (firstNameWrapper && lastNameWrapper) {
    firstNameWrapper.parentNode.insertBefore(lastNameWrapper, firstNameWrapper);
  }
}

swapElements();

